import { IS_PRODUCTION } from 'constants/envs.ts'

// Must stay in sync with the associated domains in ios/App/App/App.entitlements (applinks:) and the intent-filter hosts in
// android/app/src/main/AndroidManifest.xml. Staging is only claimed by debug builds (App.debug.entitlements, src/debug manifest).
export const DEEP_LINK_HOSTS = IS_PRODUCTION ? ['my.boltenergie.be'] : ['my.boltenergie.be', 'staging.my.boltenergie.be']
